import { Call } from "@mui/icons-material";
import { Box, Link, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./index.scss";

const ContactUs = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { t } = useTranslation();
  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "center" }} mt={2}>
        <img
          src="/images/logo.png"
          alt="logo"
          style={{ width: isMobile ? "150px" : "200px" }}
        ></img>
      </Box>
      <Stack
        justifyContent="center"
        alignContent={"center"}
        alignItems={"center"}
        mt={2}
      >
        <Typography variant="h5">{t("address")},</Typography>
        <Typography variant="h5">{t("town")}</Typography>
        <Stack direction="row" justifyContent="center" gap={1}>
          <Call color="primary" sx={{ fontSize: "30px" }} />
          <Typography variant="h5" color="primary">
            <Link href="tel:+91 94892 09189">+91 94892 09189</Link>
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default ContactUs;
